export { hasPermission } from './hasPermission'

export enum AppPermission {
  AnnouncementAppBrowse = 'announcementApp:browse',
  AnnouncementAppManage = 'announcementApp:manage',
  AuditingAppBrowse = 'auditingApp:browse',
  AuditingAppBrowseIdentityRoleLogs = 'auditApp:browseIdentityRoleLogs',
  AwardAppBrowse = 'awardApp:browse',
  AwardAppCreateAwardType = 'awardApp:createAwardType',
  AwardAppCreateNomination = 'awardApp:createNomination',
  AwardAppManage = 'awardApp:manage',
  AwardAppManageNominations = 'awardApp:manageNominations',
  AwardAppNominationSender = 'awardApp:nominationSender',
  AwardAppModerate = 'awardApp:moderate',
  AwardAppSendAnyAwardType = 'awardApp:sendAnyAwardType',
  AwardAppSendOwnAwardType = 'awardApp:sendOwnAwardType',
  AwardAppTranslate = 'awardApp:translate',
  AwardAppUpgradeLicenseNominations = 'awardApp:upgradeLicenseNominations',
  CardAppBrowse = 'cardApp:browse',
  CardAppCreateCard = 'cardApp:createCard',
  CardAppManage = 'cardApp:manage',
  CardAppModerate = 'cardApp:moderate',
  CardAppViewAnyCard = 'cardApp:viewAnyCard',
  CardAppViewOwnCard = 'cardApp:viewOwnCard',
  CardAppCreateOtherCard = 'cardApp:createOtherCard',
  CelebrationAppBrowse = 'celebrationApp:browse',
  CelebrationAppEditMemberPreferences = 'celebrationApp:editMemberPreferences',
  CelebrationAppEditTenantPreferences = 'celebrationApp:editTenantPreferences',
  CheckInAppBrowse = 'checkInApp:browse',
  CheckInAppManage = 'checkInApp:manage',
  CheckInAppUpgradeLicense = 'checkInApp:upgradeLicense',
  CheckInAppViewAnalytics = 'checkInApp:viewAnalytics',
  CommentAppModerate = 'commentApp:moderate',
  HrIntegrationAppAdmin = 'hrIntegrationApp:admin',
  HrIntegrationAppBrowse = 'hrIntegrationApp:browse',
  HrIntegrationAppBrowseFtpConnections = 'hrIntegrationApp:browseFtpConnections',
  HrIntegrationAppBrowseHistory = 'hrIntegrationApp:browseHistory',
  HrIntegrationAppCreateFtpConnection = 'hrIntegrationApp:createFtpConnection',
  IdentityAppBrowse = 'identityApp:browse',
  IdentityAppBrowseStaff = 'identityApp:browseStaff',
  IdentityAppConfigureTeamAutomation = 'identityApp:configureTeamAutomation',
  IdentityAppCreateMicrosoftIdentity = 'identityApp:createMicrosoftIdentity',
  IdentityAppCreateSlackIdentity = 'identityApp:createSlackIdentity',
  IdentityAppEditTenantPreferences = 'identityApp:editTenantPreferences',
  IdentityAppCreateTeam = 'identityApp:createTeam',
  IdentityAppEditBanner = 'identityApp:editBanner',
  IdentityAppEditJitProvisioning = 'identityApp:editJitProvisioning',
  IdentityAppEditLogo = 'identityApp:editLogo',
  IdentityAppEditSegments = 'identityApp:editSegments',
  IdentityAppEditSsoRequired = 'identityApp:editSsoRequired',
  IdentityAppExpireAllPasswords = 'identityApp:expireAllPasswords',
  IdentityAppExportMembers = 'identityApp:exportMembers',
  IdentityAppImportRecords = 'identityApp:importStaffRecords',
  IdentityAppManageAuthSettings = 'identityApp:manageAuthSettings',
  IdentityAppAutoInvite = 'identityApp:autoInvite',
  IdentityAppManageSamlProviders = 'identityApp:manageSamlProviders',
  IdentityAppEditLocale = 'identityApp:editLocale',
  IdentityAppCreateMember = 'identityApp:createMember',
  IdentityAppDeleteStaffRecords = 'identityApp:deleteStaffRecords',
  IdentityAppWelcome = 'identityApp:welcome',
  IdentityAppCreateDelegation = 'identityApp:createDelegation',
  IdentityAppManageDelegation = 'identityApp:manageDelegation',
  IdentityAppBrowseDelegators = 'identityApp:browseDelegators',
  IncentiveAppBrowse = 'incentiveApp:browse',
  IncentiveAppCreateIncentive = 'incentiveApp:createIncentive',
  IncentiveAppManage = 'incentiveApp:manage',
  IncentiveAppReview = 'incentiveApp:review',
  IncentiveAppUpgradeLicense = 'incentiveApp:upgradeLicense',
  IncentiveAppTranslate = 'incentiveApp:translate',
  MetricAppBrowse = 'metricApp:browse',
  MetricAppOwnReportsBrowse = 'metricApp:browseOwnReports',
  NotificationAppBrowseMessages = 'notificationApp:browseMessages',
  NotificationAppManageOwnPreferences = 'notificationApp:manageOwnPreferences',
  OnboardingAppManage = 'onboardingApp:manage',
  OnboardingAppBrowse = 'onboardingApp:browse',
  PointsAppViewPointsConfiguration = 'pointsApp:viewPointsConfiguration',
  PointsAppRedeemPoints = 'pointsApp:redeemPoints',
  PointsAppBrowse = 'pointsApp:browse',
  PointsAppCreateBudgetItem = 'pointsApp:createBudgetItem',
  PointsAppEditBudgetSettings = 'pointsApp:editBudgetSettings',
  PointsAppSendPoints = 'pointsApp:sendPoints',
  PointsAppReceivePoints = 'pointsApp:receivePoints',
  PointsAppViewTransactions = 'pointsApp:viewTransactions',
  RecognitionAppBrowse = 'recognitionApp:browse',
  RecognitionAppCreateRecognition = 'recognitionApp:createRecognition',
  RecognitionAppManage = 'recognitionApp:manage',
  RecognitionAppManagePointPresets = 'recognitionApp:managePointPresets',
  RecognitionAppManageNotificationSettings = 'recognitionApp:manageNotificationSettings',
  RecognitionAppModerate = 'recognitionApp:moderate',
  RecognitionAppScheduleRecognition = 'recognitionApp:scheduleRecognition',
  RecognitionAppTranslate = 'recognitionApp:translate',
  RecognitionAppUpgradeLicense = 'recognitionApp:upgradeLicense',
  RefinementAppRefineRecognition = 'refinementApp:refineRecognition',
  RefinementAppUpgradeLicense = 'refinementApp:upgradeLicense',
  ReportingAppBrowse = 'reportingApp:browse',
  ReportingAppManage = 'reportingApp:manage',
  ResourceAppBrowse = 'resourceApp:browse',
  ResourceAppUpgradeLicense = 'resourceApp:upgradeLicense',
  RewardsAppAdmin = 'rewardsApp:admin',
  RewardsAppBrowseTangoProviders = 'rewardsApp:browseTangoProviders',
  RewardsAppCreateTangoProvider = 'rewardsApp:createTangoProvider',
  RewardsAppManageTangoProviders = 'rewardsApp:manageTangoProviders',
  RewardsAppRedeem = 'rewardsApp:redeem',
  RewardsAppViewRedemptionHistory = 'rewardsApp:viewRedemptionHistory',
  RewardsAppCreateCustomRewardProvider = 'rewardsApp:createCustomRewardProvider',
  RewardsAppUpgradeLicenseCustomRewards = 'rewardsApp:upgradeLicenseCustomRewards',
  SpacesAppBrowse = 'spacesApp:browse',
  SpacesAppCreateSpace = 'spacesApp:createSpace',
  SpacesAppManage = 'spacesApp:manage',
  SpacesAppManageCreators = 'spacesApp:manageCreators',
  SpacesAppUpgradeLicense = 'spacesApp:upgradeLicense',
  SpacesAppBrowseNew = 'spacesApp:browseNew',
  TimelineAppBrowse = 'timelineApp:browse',
  TimelineAppManage = 'timelineApp:manage',
  TvAppAddChannel = 'tvApp:addChannel',
  TvAppBrowse = 'tvApp:browse',
  TvAppRestrictAudience = 'tvApp:restrictAudience',
  TvAppUpgradeLicenseAudience = 'tvApp:upgradeLicenseAudience',
  ValueAppBrowseCulture = 'valueApp:browseCulture',
  ValueAppCreateValue = 'valueApp:createValue',
  ValueAppTranslate = 'valueApp:translate',
}

export enum ChannelPermission {
  Edit = 'channel:edit',
  Delete = 'channel:delete',
  EditAudience = 'channel:editAudience',
}

export enum TenantMemberPermission {
  ChangeRole = 'tenantMember:changeRole',
  Suspend = 'tenantMember:suspend',
  Unsuspend = 'tenantMember:unsuspend',
  Edit = 'tenantMember:edit',
  EditAvatar = 'tenantMember:editAvatar',
  Welcome = 'tenantMember:welcome',
}

export enum SamlProviderPermission {
  Edit = 'samlProvider:edit',
  Delete = 'samlProvider:delete',
  Activate = 'samlProvider:activate',
  Deactivate = 'samlProvider:deactivate',
}

export enum UserPermission {
  ChangePassword = 'user:changePassword',
  CreateAuthFactor = 'user:createAuthFactor',
}

export enum AuthFactorPermission {
  Delete = 'auth_factor:delete',
}

export enum CheckInPermission {
  Configure = 'checkInCategory:configure',
}

export enum TeamAutomationPermission {
  Edit = 'teamAutomation:edit',
  Disable = 'teamAutomation:disable',
  Sync = 'teamAutomation:sync',
  Delete = 'teamAutomation:delete',
}

export enum TeamPermission {
  Automate = 'team:automate',
  Edit = 'team:edit',
  Delete = 'team:delete',
  ManageMembers = 'team:manageMembers',
}

export enum ValuePermission {
  Edit = 'value:edit',
  Delete = 'value:delete',
}

export enum RecognitionPermission {
  Edit = 'recognition:edit',
  EditPublished = 'recognition:editPublished',
  Endorse = 'recognition:endorse',
  Schedule = 'recognition:schedule',
  React = 'recognition:react',
  Flag = 'recognition:flag',
  Comment = 'recognition:comment',
  Moderate = 'recognition:moderate',
  Delete = 'recognition:delete',
}

export enum CommentPermission {
  Flag = 'comment:flag',
  Edit = 'comment:edit',
  DismissFlags = 'comment:dismissFlags',
  React = 'comment:react',
  Delete = 'comment:delete',
}

export enum BudgetItemPermission {
  Edit = 'budgetItem:edit',
  Delete = 'budgetItem:delete',
  Usage = 'budgetItem:usage',
}

export enum ResourcePermission {
  React = 'resource:react',
}

export enum RewardProviderPermission {
  Edit = 'rewardProvider:edit',
  Delete = 'rewardProvider:delete',
  Redeem = 'rewardProvider:redeem',
}

export enum CustomRewardProviderPermission {
  Edit = 'customRewardProvider:edit',
  Manage = 'customRewardProvider:manage',
  Enable = 'customRewardProvider:enable',
  Disable = 'customRewardProvider:disable',
  CreateReward = 'customRewardProvider:createReward',
}

export enum CustomRewardPermissions {
  Edit = 'customReward:edit',
  Inactive = 'customReward:inactivate',
  Activate = 'customReward:activate',
  Schedule = 'customReward:schedule',
  Delete = 'customReward:delete',
  Feature = 'customReward:feature',
  UnFeature = 'customReward:unFeature',
  ManageOrders = 'customReward:manageOrders',
  AdjustInventory = 'customReward:adjustInventory',
}

export enum CustomRewardOrderPemissions {
  Cancel = 'customRewardOrder:cancel',
  Completed = 'customRewardOrder:complete',
}

export enum AwardTypePermission {
  Edit = 'awardType:edit',
  Send = 'awardType:send',
  Archive = 'awardType:archive',
  Unarchive = 'awardType:unarchive',
  Export = 'awardType:exportRecipients',
  Delete = 'awardType:delete',
  Nominate = 'awardType:nominate',
  ViewNominees = 'awardType:viewNominees',
  EditWinners = 'awardType:editWinners',
  Finalize = 'awardType:finalize',
  ExportNominations = 'awardType:exportNominations',
  End = 'awardType:end',
  Extend = 'awardType:extend',
  Start = 'awardType:start',
}

export enum AwardPermission {
  Flag = 'award:flag',
  Endorse = 'award:endorse',
  Comment = 'award:comment',
  React = 'award:react',
  Edit = 'award:edit',
}

export enum CardPermission {
  Sign = 'card:sign',
  Edit = 'card:edit',
  Invite = 'card:invite',
  View = 'card:view',
  Download = 'card:download',
  Delete = 'card:delete',
}

export enum CardBackgroundPermission {
  Delete = 'cardBackground:delete',
  SetDefault = 'cardBackground:setDefault',
  Disable = 'cardBackground:disable',
}

export enum CardContributorPermission {
  Flag = 'cardContributor:flag',
  Edit = 'cardContributor:edit',
}

export enum ReportPermissions {
  View = 'report:view',
  ManagerView = 'report:managerView',
  ExportXLSX = 'report:exportXlsx',
  Share = 'report:share',
  ShareViaEmail = 'report:shareViaEmail',
  Favourite = 'report:favourite',
}

export enum AnnouncementPermission {
  Edit = 'announcement:edit',
  EditActive = 'announcement:editActive',
  Clone = 'announcement:clone',
  Delete = 'announcement:delete',
  Participate = 'announcement:participate',
}

export enum TangoProviderPermission {
  Edit = 'tangoProvider:edit',
  AddCreditCard = 'tangoProvider:addCreditCard',
  ManageCreditCard = 'tangoProvider:manageCreditCard',
  Fund = 'tangoProvider:fund',
  BrowseDeposits = 'tangoProvider:browseDeposits',
}

export enum IncentivePermission {
  Edit = 'incentive:edit',
  Claim = 'incentive:claim',
  Review = 'incentive:review',
  ExportClaims = 'incentive:exportClaims',
  Start = 'incentive:start',
  End = 'incentive:end',
  Delete = 'incentive:delete',
}

export enum TransactionRecipientPermission {
  Reverse = 'transactionRecipient:reverse',
}

export enum AccountPermission {
  AddPoints = 'account:addPoints',
  RemovePoints = 'account:removePoints',
  Allocate = 'account:allocate',
  Expire = 'account:expire',
  Enable = 'account:enablePoints',
  Disable = 'account:disablePoints',
  SendDelegatedPoints = 'account:sendDelegatedPoints',
}

export enum StaffRecordPermissionsEnum {
  Invite = 'staffRecord:invite',
  Delete = 'staffRecord:delete',
}

export enum FtpConnectionPermission {
  Edit = 'ftpConnection:edit',
  Activate = 'ftpConnection:activate',
  Inactivate = 'ftpConnection:inactivate',
  Delete = 'ftpConnection:delete',
  Sync = 'ftpConnection:sync',
}

export enum CustomRewardVariantPermission {
  Redeem = 'customRewardVariant:redeem',
}

export enum DelegationPermissionsEnum {
  Edit = 'delegation:edit',
  Delete = 'delegation:delete',
}

export enum SpacePermissions {
  Edit = 'space:edit',
  CreatePost = 'space:createPost',
  CreateAlbum = 'space:createAlbum',
  Archive = 'space:archive',
  Unarchive = 'space:unarchive',
  Subscribe = 'space:subscribe',
  MarkAsSeen = 'space:markAsSeen',
}

export enum PostPermissions {
  Archive = 'post:archive',
  Comment = 'post:comment',
  React = 'post:react',
  Pin = 'post:pin',
  DeleteComments = 'post:deleteComments',
  Edit = 'post:edit',
  AddPhoto = 'post:addPhoto',
  ArchiveOwnPhotos = 'post:archiveOwnPhotos',
  ArchiveAnyPhotos = 'post:archiveAnyPhotos',
}

export enum PhotoPermissionsEnum {
  COMMENT = 'photo:comment',
  REACT = 'photo:react',
  ARCHIVE = 'photo:archive',
  DELETE_COMMENTS = 'photo:deleteComments',
}
